// extracted by mini-css-extract-plugin
export var active = "_do-7";
export var container = "_do-0";
export var evenWidth = "_do-4";
export var large = "_do-5";
export var outlet = "_do-8";
export var slide = "_do-2";
export var small = "_do-6";
export var tab = "_do-3";
export var tabs = "_do-1";